import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-quotation-validate-coverages',
  templateUrl: './quotation-validate-coverages.component.html',
  styleUrls: ['./quotation-validate-coverages.component.scss'],
  standalone: true,
  imports: [TranslateModule, MatButtonModule],
})
export class QuotationValidateCoveragesComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<QuotationValidateCoveragesComponent>) {}

  ngOnInit(): void {}

  resetQuotation() {
    location.reload();
  }

  public closeModal(): void {
    this.dialogRef.close();
  }
}
